import React from "react";
import "./SimulationHeader.css";

export default function SimulationHeader(props) {
  const formatTimeRemaining = (timeRemaining) => {
    let hours = Math.floor(timeRemaining / 3600);
    let minutes = Math.floor(timeRemaining / 60);
    let seconds = timeRemaining % 60;

    if (hours < 10) {
      hours = `0${hours}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
    return `${hours}:${minutes}:${seconds}`;
  };

  const getTimerSpeedDisplay = () => {
    const speed = props.timerSpeed || "1x";
    return speed !== "1x" ? ` (${speed})` : "";
  };

  return (
    <div className="simulationHeaderContainer" id="headerContainer">
      <div className="simulationHeaderLeftContentWrapper">
        <h3 className="simulationHeaderText">
          Question {props.currentQuestion} of{" "}
          {props.simulationData.TOTALNUMQUESTIONS}
        </h3>

        {/* Text editing controls */}
        <div className="simulationHeaderTextControls">
          <button
            className={`simulationHeaderTextButton ${
              props.textEditModes.highlight ? "active" : ""
            }`}
            onClick={props.toggleHighlight}
            title={
              props.textEditModes.highlight ? "Highlight enabled" : "Highlight"
            }
          >
            <span className="highlight-icon">🖍️</span>
            {props.textEditModes.highlight ? "Highlight ON" : "Highlight"}
          </button>

          <button
            className={`simulationHeaderTextButton ${
              props.textEditModes.strikeThrough ? "active" : ""
            }`}
            onClick={props.toggleStrikeThrough}
            title={
              props.textEditModes.strikeThrough
                ? "Strikethrough enabled"
                : "Strikethrough"
            }
          >
            <span className="strikethrough-icon">⚏</span>
            {props.textEditModes.strikeThrough ? "Strike ON" : "Strike"}
          </button>

          {props.openSettings && (
            <button
              type="button"
              className={`simulationHeaderTextButton ${
                props.settingsOpen ? "active" : ""
              }`}
              onClick={props.openSettings}
              aria-haspopup="dialog"
              aria-expanded={!!props.settingsOpen}
              title="Settings"
            >
              <svg
                className="simulationHeaderSettingsIcon"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M19.14 12.94a7.43 7.43 0 0 0 .06-.94 7.43 7.43 0 0 0-.06-.94l2.03-1.58a.48.48 0 0 0 .12-.61l-1.92-3.32a.48.48 0 0 0-.59-.21l-2.39.96a7.1 7.1 0 0 0-1.62-.94l-.36-2.54A.47.47 0 0 0 13.93 2h-3.86a.47.47 0 0 0-.47.4l-.36 2.54a7.36 7.36 0 0 0-1.62.94l-2.39-.96a.48.48 0 0 0-.59.21L2.72 8.45a.47.47 0 0 0 .12.61l2.03 1.58a7.43 7.43 0 0 0-.06.94c0 .32.02.63.06.94l-2.03 1.58a.48.48 0 0 0-.12.61l1.92 3.32c.12.21.37.3.59.21l2.39-.96c.5.38 1.04.7 1.62.94l.36 2.54c.04.23.24.4.47.4h3.86c.23 0 .43-.17.47-.4l.36-2.54a7.36 7.36 0 0 0 1.62-.94l2.39.96c.22.09.47 0 .59-.21l1.92-3.32a.48.48 0 0 0-.12-.61l-2.03-1.58zM12 15.6A3.6 3.6 0 1 1 12 8.4a3.6 3.6 0 0 1 0 7.2z" />
              </svg>
              Settings
            </button>
          )}
        </div>
      </div>

      <div className="simulationHeaderCenterContent">
        <h3 className="simulationHeaderText">CDM Practice Exam</h3>
      </div>

      <div className="simulationHeaderRightContentWrapper">
        <h3 className="simulationHeaderText">
          Time remaining for this session:
        </h3>
        {props.timedExam ? (
          <h3 className="simulationHeaderText">
            {formatTimeRemaining(props.timeRemaining)}
            {getTimerSpeedDisplay()}
          </h3>
        ) : (
          <h3 className="simulationHeaderText">Untimed</h3>
        )}
      </div>
      <button
        className="simulationHeaderLabPanelsButton"
        onClick={props.displayLabPanels}
      >
        LAB PANELS
      </button>
    </div>
  );
}